import { Component, ElementRef, input, output, viewChild } from '@angular/core';

@Component({
	selector: 'ui-select-button',
	templateUrl: './select-button.component.html',
	standalone: false,
})
export class SelectButtonComponent {
	label = input<string>('');
	icon = input<string>('');
	disabled = input<boolean>(false);
	primary = input<boolean>(false);
	tabindex = input<number>(0);

	buttonClicked = output<Event>();

	buttonElement = viewChild<ElementRef<HTMLDivElement>>('buttonElement');

	click(event: Event) {
		if (!this.disabled()) {
			this.buttonClicked.emit(event);
		}
	}

	onKeyDown(event: KeyboardEvent) {
		if ((event.key === 'Enter' || event.key === ' ') && !this.disabled()) {
			event.preventDefault();
			event.stopPropagation();
			this.buttonClicked.emit(event);
		}
	}

	focus(): void {
		if (this.disabled()) {
			return;
		}
		this.buttonElement()?.nativeElement.focus();
	}
}
